import React from "react";

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
}

export const FormInput = ({ label, id, ...props }: FormInputProps) => {
    return (
        <div>
            {label && (
                <label htmlFor={id} className="block text-xs text-gray-500 mb-2">
                    {label}
                </label>
            )}
            <input
                id={id}
                {...props}
                className={`w-full px-4 py-3 border-b border-gray-400 focus:outline-none text-xs bg-transparent transition-colors focus:border-neutral ${props.className || ""}`}
            />
        </div>
    );
};

export default FormInput;
